var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-dropzone',{ref:"myDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.fileUploaded,"vdropzone-files-added":_vm.handleFilesAdded}})
}
var staticRenderFns = []

export { render, staticRenderFns }